import axios from "axios"
import FormButton from "../../components/FormButton"
import { getToken } from "../../user/User"
import { toast } from "react-toastify"
import { useNavigate } from "react-router-dom"

const SectorDetailView = ({ id,         
    name, setName,
}) => {
    const navigate = useNavigate()
    
    const handleBack = async e => {
        e.preventDefault()
        navigate("/sector")
    }

    const onSave = async e => {
        e.preventDefault()

        axios.put(process.env.REACT_APP_API_URL + "/api/sectors/" + id, JSON.stringify({
            "name": name,
        }), { headers: {
            "Authorization": "Bearer " + getToken()
        }}).then(_ => {
            toast.success("Saved sector " + name + " (#" + id + ").")
        }).catch(error => {
            if (error.response) {
                var statusCode = error.response.status
                if(statusCode === 400) {
                    toast.error("Invalid request.")
                    return
                } else if(statusCode === 404) {
                    toast.error("Unable to find sector #" + id + ".")
                    return
                } else if(statusCode === 409) {
                    toast.error("There is a sector with the same name.")
                    return
                }
            }
            toast.error("Internal error")
        })
    }

    const onDelete = async e => {
        e.preventDefault()
        navigate("/sector/delete/" + id)
    }
    
    const onCreate = async e => {
        e.preventDefault()
        axios.post(process.env.REACT_APP_API_URL + "/api/sectors", JSON.stringify({
            "name": name,
        }), { headers: {
            "Authorization": "Bearer " + getToken()
        }}).then(res => {
            toast.success("Created sector " + name + " (#" + res.data.id + ").")
            navigate("/sector/" + res.data.id)
        }).catch(error => {
            if (error.response) {
                var statusCode = error.response.status
                if(statusCode === 400) {
                    toast.error("Invalid request.")
                    return
                } else if(statusCode === 409) {
                    toast.error("There is a sector with the same name.")
                    return
                }
            }
            toast.error("Internal error")
        })
    }
    
    return (
        <>
            <button className="btn btn-primary back" onClick={handleBack}>Back to overview</button><br /><br />

            <form className="form-horizontal">
                <div className="card card-primary">
                    <div className="card-body">
                        <div className="col-12">
                            <div className="row">
                                <FormButton label="Name" id="name" required="required" value={name} setValue={setName} icon="fa-solid fa-buildings" />
                            </div>
                        </div>
                    </div>

                    <div className="card-footer">
                        {id === null ? (
                            <button className="btn btn-success" onClick={onCreate}>Create sector</button>
                        ) : (
                            <>
                                <button className="btn btn-primary" onClick={onSave}>Save sector</button>
                                <button className="btn btn-danger" onClick={onDelete}>Delete sector</button>
                            </>
                        )}
                    </div>
                </div>
            </form>
        </>
    )
}
   
export default SectorDetailView